<template>
  <AppButtonOk
    :disabled="currentStep >= steps.length"
    @click="onClickNext"
    :color="color"
  >
    <v-icon :color="btnColor" large>mdi-menu-right</v-icon>
  </AppButtonOk>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SimulationFooterButtonNext',
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters('simulation', ['currentStep', 'steps']),
    basicSetting() {
      return this.form.basicSetting
    },
    color() {
      if (this.currentStep === 1) {
        return 'primary'
      }
      return ''
    },
    btnColor() {
      if (this.currentStep === 1) {
        return 'white'
      }
      return ''
    },
  },
  methods: {
    ...mapActions('simulation', {
      nextStep: 'NEXT_STEP',
    }),
    async onClickNext() {
      // 共有Simの場合と読み取り専用の場合Validを考慮しない
      if (
        window.location.search.includes('hashId') &&
        this.basicSetting.isReadOnly
      ) {
        await this.nextStep()
        return
      }
      const errors = this.basicSetting.validation()
      if (errors.length) {
        await this.$confirm('入力エラー', {
          okText: '閉じる',
          onlyOk: true,
          body: errors.join('\n'),
        })
        return false
      }

      await this.nextStep()
    },
  },
}
</script>

<style scoped></style>
